export const precautionaryStatements = {
    P101: 'If medical advice is needed, have product container or label at hand.',
    P102: 'Keep out of reach of children.',
    P103: 'Read carefully and follow all instructions.',
    P201: '(Deleted) Obtain special instructions before use.',
    P202: '(Deleted) Do not handle until all safety precautions have been read and understood.',
    P203: 'Obtain, read and follow all safety instructions before use.',
    P210: 'Keep away from heat, hot surface, sparks, open flames and other ignition sources. No smoking.',
    P211: 'Do not spray on an open flame or other ignition source.',
    P212: 'Avoid heating under confinement or reduction of the desensitized agent.',
    P220: 'Keep away from clothing and other combustible materials.',
    P221: '(Deleted) Take any precaution to avoid mixing with combustibles/...',
    P222: 'Do not allow contact with air.',
    P223: 'Do not allow contact with water.',
    P230: 'Keep wetted with ...',
    P231: 'Handle and store contents under inert gas/...',
    P232: 'Protect from moisture.',
    P233: 'Keep container tightly closed.',
    P234: 'Keep only in original container.',
    P235: 'Keep cool.',
    P236: 'Keep only in original packaging; Division .. in the transport configuration.',
    P240: 'Ground/bond container and receiving equipment.',
    P241: 'Use explosion-proof [electrical/ventilating/lighting/.../] equipment.',
    P242: 'Use only non-sparking tools.',
    P243: 'Take precautionary measures against static discharge.',
    P244: 'Keep valves and fittings free from oil and grease.',
    P250: 'Do not subject to grinding/shock/friction/...',
    P251: 'Do not pierce or burn, even after use.',
    P260: 'Do not breathe dust/fume/gas/mist/vapors/spray.',
    P261: 'Avoid breathing dust/fume/gas/mist/vapors/spray.',
    P262: 'Do not get in eyes, on skin, or on clothing.',
    P263: 'Avoid contact during pregnancy/while nursing.',
    P264: 'Wash hands [and ...] thoroughly after handling.',
    P265: 'Do not touch eyes.',
    P270: 'Do not eat, drink or smoke when using this product.',
    P271: 'Use only outdoors or in a well-ventilated area.',
    P272: 'Contaminated work clothing should not be allowed out of the workplace.',
    P273: 'Avoid release to the environment.',
    P280: 'Wear protective gloves/protective clothing/eye protection/face protection/hearing protection/...',
    P281: '(Deleted)Use personal protective equipment as required.',
    P282: 'Wear cold insulating gloves and either face shield or eye protection.',
    P283: 'Wear fire resistant or flame retardant clothing.',
    P284: '[In case of inadequate ventilation] Wear respiratory protection.',
    P285: '(Deleted) In case of inadequate ventilation wear respiratory protection.',
    'P231+P232': 'Handle and store contents under inert gas/... Protect from moisture.',
    'P264+P265': 'Wash hands [and ...] thoroughly after handling. Do not touch eyes.',
    'P235+P410': '(Deleted) Keep cool. Protect from sunlight.',
    P301: 'IF SWALLOWED:',
    P302: 'IF ON SKIN:',
    P303: 'IF ON SKIN (or hair):',
    P304: 'IF INHALED:',
    P305: 'IF IN EYES:',
    P306: 'IF ON CLOTHING:',
    P307: '(Deleted) IF exposed:',
    P308: 'IF exposed or concerned:',
    P309: '(Deleted) IF exposed or if you feel unwell',
    P310: '(Deleted) Immediately call a POISON CENTER or doctor/physician.',
    P311: '(Deleted) Call a POISON CENTER or doctor/...',
    P312: '(Deleted) Call a POISON CENTER or doctor/... if you feel unwell.',
    P313: '(Deleted) Get medical advice/attention.',
    P314: '(Deleted) Get medical advice/attention if you feel unwell.',
    P315: '(Deleted) Get immediate medical advice/attention.',
    P316: 'Get emergency medical help immediately.',
    P317: 'Get emergency medical help.',
    P318: 'if exposed or concerned, get medical advice.',
    P319: 'Get medical help if you feel unwell.',
    P320: 'Specific treatment is urgent (see ... on this label).',
    P321: 'Specific treatment (see ... on this label).',
    P322: '(Deleted) Specific measures (see ...on this label).',
    P330: 'Rinse mouth.',
    P331: 'Do NOT induce vomiting.',
    P332: 'IF SKIN irritation occurs:',
    P333: 'If skin irritation or rash occurs:',
    P334: 'Immerse in cool water [or wrap in wet bandages].',
    P335: 'Brush off loose particles from skin.',
    P336: 'Thaw frosted parts with lukewarm water. Do not rub affected area.',
    P337: 'If eye irritation persists:',
    P338: 'Remove contact lenses, if present and easy to do. Continue rinsing.',
    P340: 'Remove person to fresh air and keep comfortable for breathing.',
    P341: '(Deleted) If breathing is difficult, remove victim to fresh air and keep at rest in a position comfortable for breathing.',
    P342: 'If experiencing respiratory symptoms:',
    P350: '(Deleted) Gently wash with plenty of soap and water.',
    P351: 'Rinse cautiously with water for several minutes.',
    P352: 'Wash with plenty of water/...',
    P353: 'Rinse skin with water [or shower].',
    P354: 'Immediately rinse with water for several minutes.',
    P360: 'Rinse immediately contaminated clothing and skin with plenty of water before removing clothes.',
    P361: 'Take off immediately all contaminated clothing.',
    P362: 'Take off contaminated clothing.',
    P363: 'Wash contaminated clothing before reuse.',
    P364: 'And wash it before reuse.',
    P370: 'In case of fire:',
    P371: 'In case of major fire and large quantities:',
    P372: 'Explosion risk.',
    P373: 'DO NOT fight fire when fire reaches explosives.',
    P374: '(Deleted) Fight fire with normal precautions from a reasonable distance.',
    P375: 'Fight fire remotely due to the risk of explosion.',
    P376: 'Stop leak if safe to do so.',
    P377: 'Leaking gas fire: Do not extinguish, unless leak can be stopped safely.',
    P378: 'Use ... to extinguish.',
    P380: 'Evacuate area.',
    P381: 'In case of leakage, eliminate all ignition sources.',
    P390: 'Absorb spillage to prevent material damage.',
    P391: 'Collect spillage.',
    'P301+P310': '(Deleted) IF SWALLOWED: Immediately call a POISON CENTER/doctor/...',
    'P301+P312': '(Deleted) IF SWALLOWED: call a POISON CENTER/doctor/... IF you feel unwell.',
    'P301+P316': 'IF SWALLOWED: Get emergency medical help immediately.',
    'P301+P317': 'IF SWALLOWED: Get medical help.',
    'P301+P330+P331': 'IF SWALLOWED: Rinse mouth. Do NOT induce vomiting.',
    'P302+P317': 'IF ON SKIN: Get medical help.',
    'P302+P334': 'IF ON SKIN: Immerse in cool water or wrap in wet bandages.',
    'P302+P335+P334': 'Brush off loose particles from skin. Immerse in cool water [or wrap in wet bandages].',
    'P302+P350': '(Deleted) IF ON SKIN: Gently wash with plenty of soap and water.',
    'P302+P352': 'IF ON SKIN: wash with plenty of water/...',
    'P302+P361+P354': 'IF ON SKIN: Take off Immediately all contaminated clothing. Immediately rinse with water for several minutes.',
    'P303+P361+P353': 'IF ON SKIN (or hair): Take off Immediately all contaminated clothing. Rinse SKIN with water [or shower].',
    'P304+P312': '(Deleted) IF INHALED: Call a POISON CENTER/doctor/... if you feel unwell.',
    'P304+P317': 'IF INHALED: Get medical help.',
    'P304+P340': 'IF INHALED: Remove person to fresh air and keep comfortable for breathing.',
    'P304+P341': '(Deleted) IF INHALED: If breathing is difficult, remove victim to fresh air and keep at rest in a position comfortable for breathing.',
    'P305+P351+P338': 'IF IN EYES: Rinse cautiously with water for several minutes. Remove contact lenses if present and easy to do - continue rinsing.',
    'P305+P354+P338': 'IF IN EYES: Immediately rinse with water for several minutes. Remove contact lenses if present and easy to do. Continue rinsing.',
    'P306+P360': 'IF ON CLOTHING: Rinse Immediately contaminated CLOTHING and SKIN with plenty of water before removing clothes.',
    'P308+P316': 'IF exposed or concerned: Get emergency medical help immediately.',
    'P307+P311': '(Deleted) IF exposed: call a POISON CENTER or doctor/physician.',
    'P308+P311': '(Deleted) IF exposed or concerned: Call a POISON CENTER/doctor/...',
    'P308+P313': '(Deleted) IF exposed or concerned: Get medical advice/attention.',
    'P309+P311': '(Deleted) IF exposed or if you feel unwell: call a POISON CENTER or doctor/physician.',
    'P332+P313': '(Deleted) IF SKIN irritation occurs: Get medical advice/attention.',
    'P332+P317': 'If skin irritation occurs: Get medical help.',
    'P333+P317': 'If skin irritation or rash occurs: Get medical help.',
    'P336+P317': 'Immediately thaw frosted parts with lukewarm water. Do not rub affected area. Get medical help.',
    'P337+P317': 'If eye irritation persists: Get medical help.',
    'P342+P316': 'If experiencing respiratory symptoms: Get emergence medical help immediately.',
    'P333+P313': '(Deleted) IF SKIN irritation or rash occurs: Get medical advice/attention.',
    'P335+P334': '(Deleted) Brush off loose particles from skin. Immerse in cool water/wrap in wet bandages.',
    'P337+P313': '(Deleted) IF eye irritation persists: Get medical advice/attention.',
    'P342+P311': '(Deleted) IF experiencing respiratory symptoms: Call a POISON CENTER/doctor/...',
    'P361+P364': 'Take off immediately all contaminated clothing and wash it before reuse.',
    'P362+P364': 'Take off contaminated clothing and wash it before reuse.',
    'P370+P376': 'in case of fire: Stop leak if safe to do so.',
    'P370+P378': 'In case of fire: Use ... to extinguish.',
    'P370+P380': '(Deleted) In case of fire: Evacuate area.',
    'P370+P380+P375': 'In case of fire: Evacuate area. Fight fire remotely due to the risk of explosion.',
    'P371+P380+P375': 'In case of major fire and large quantities: Evacuate area. Fight fire remotely due to the risk of explosion.',
    'P370+P372+P380+P373': 'In case of fire: Explosion risk. Evacuate area. DO NOT fight fire when fire reaches explosives.',
    'P370+P380+P375[+P378]': 'In case of fire: Evacuate area. Fight fire remotely due to the risk of explosion. [Use...to extinguish].]',
    P401: 'Store in accordance with ...',
    P402: 'Store in a dry place.',
    P403: 'Store in a well-ventilated place.',
    P404: 'Store in a closed container.',
    P405: 'Store locked up.',
    P406: 'Store in corrosive resistant/... container with a resistant inner liner.',
    P407: 'Maintain air gap between stacks or pallets.',
    P410: 'Protect from sunlight.',
    P411: 'Store at temperatures not exceeding ... °C/...°F.',
    P412: 'Do not expose to temperatures exceeding 50 °C/ 122 °F.',
    P413: 'Store bulk masses greater than ... kg/...lbs at temperatures not exceeding ... °C/...°F.',
    P420: 'Store separately.',
    P422: '(Deleted) Store contents under ...',
    'P402+P404': 'Store in a dry place. Store in a closed container.',
    'P403+P233': 'Store in a well-ventilated place. Keep container tightly closed.',
    'P403+P235': 'Store in a well-ventilated place. Keep cool.',
    'P410+P403': 'Protect from sunlight. Store in a well-ventilated place.',
    'P410+P412': 'Protect from sunlight. Do not expose to temperatures exceeding 50 °C/122°F.',
    'P411+P235': '(Deleted) Store at temperatures not exceeding ... °C/...°F. Keep cool.',
    P501: 'Dispose of contents/container to ...',
    P502: 'Refer to manufacturer or supplier for information on recovery or recycling',
    P503: 'Refer to manufacturer/supplier... for information on disposal/recovery/recycling.',
};
//# sourceMappingURL=precautionaryStatements.js.map